export const PageData = {
    introduction: [
    {
        heading: "Introduction",
        id: 1,
        text: [
            {
                id: 1,
                subtitle: "Opening: ",
                body: "With Donald Trump’s recent election win, questions are arising about the future of U.S. immigration policy. His previous term included significant shifts in immigration law, and his return to office is expected to bring both new policies and potential changes to existing ones.",
            },
            {
                id: 2,
                subtitle: "Goal: ",
                body: "This blog will outline what Trump’s victory might mean for immigration policies, the likely changes on the horizon, and how GIT Global can help you navigate these developments.",
            },
        ]
    },
    ],
    potentialChanges: [
        {
            heading: "Potential Changes to Immigration Under Trump",
            id: 1,
            procedures: [
                {
                    title: "Tighter Border Security and Enforcement",
                    id: 1,
                    steps: [
                        {
                            id: 1,
                            subtitle: "What to Expect: ",
                            body: "Trump has previously emphasized stricter border security, so we may see renewed focus on border wall construction, increased funding for border patrol, and policies aimed at deterring unauthorized immigration.",
                        },
                        {
                            id: 2,
                            subtitle: "Impact: ",
                            body: "This focus could lead to longer wait times and enhanced scrutiny at points of entry, impacting certain visa applications and travel.",
                        },
                    ],
                },
                {
                    title: "Changes to Family-Based Immigration",
                    id: 2,
                    steps: [
                        {
                            id: 1,
                            subtitle: "What to Expect: ",
                            body: "Family-based immigration policies could come under more scrutiny, with potential efforts to restrict family reunification and limit the number of visas granted to extended family members.",
                        },
                        {
                            id: 2,
                            subtitle: "Impact: ",
                            body: "Applicants for family-based visas may experience increased processing times and may need to provide additional evidence to demonstrate the legitimacy of family relationships.",
                        },
                    ],
                },
                {
                    title: "Revised Rules for Refugee and Asylum Programs",
                    id: 3,
                    steps: [
                        {
                            id: 1,
                            subtitle: "What to Expect: ",
                            body: "During his previous administration, Trump implemented restrictions on refugee admissions and imposed limits on asylum applications. A renewed focus on asylum and refugee vetting procedures could impact the number of refugees admitted each year.",
                        },
                        {
                            id: 2,
                            subtitle: "Impact: ",
                            body: "Individuals seeking asylum or refugee status may face longer processing times and stricter requirements for demonstrating eligibility.",
                        },
                    ],
                },
                {
                    title: "Possible Revisions to the DACA Program",
                    id: 4,
                    steps: [
                        {
                            id: 1,
                            subtitle: "What to Expect: ",
                            body: "The Deferred Action for Childhood Arrivals (DACA) program has been a highly debated policy, with previous efforts to rescind it under Trump. A renewed effort to end or alter DACA could impact the legal status of hundreds of thousands of Dreamers.",
                        },
                        {
                            id: 2,
                            subtitle: "Impact: ",
                            body: "This could create uncertainties for Dreamers currently protected under DACA, potentially impacting their work permits and ability to remain in the U.S.",
                        },
                    ],
                },
                {
                    title: "Changes to Employment-Based Immigration",
                    id: 5,
                    steps: [
                        {
                            id: 1,
                            subtitle: "What to Expect: ",
                            body: "Employment-based visas, such as H-1B and L-1, may also be reviewed. Previous policies aimed to prioritize American workers and reduce dependency on foreign labor, and similar initiatives could be proposed again.",
                        },
                        {
                            id: 2,
                            subtitle: "Impact: ",
                            body: "Employers may face stricter hiring requirements, while applicants could encounter additional challenges in obtaining or renewing employment-based visas.",
                        },
                    ],
                },
            ]
        },
    ],
    afterApplication: [
        {
            heading: "How GIT Global Can Help You Prepare",
            subheading: "Navigating potential immigration changes can be challenging, especially with the possibility of new policies and regulations. Here’s how GIT Global can assist you:",
            id: 1,
            text: [
                {
                    id: 1,
                    subtitle: "Up-to-Date Guidance: ",
                    body: "Our team stays informed about the latest immigration policies, ensuring you have accurate information on how any changes might impact your case.",
                },
                {
                    id: 2,
                    subtitle: "Document Preparation and Review: ",
                    body: "GIT Global helps ensure that all necessary documents are submitted correctly, reducing the chance of delays or rejections.",
                },
                {
                    id: 3,
                    subtitle: "Support in Uncertain Times: ",
                    body: "With potential policy shifts on the horizon, GIT Global is here to provide clarity and support for immigrants and their families seeking stability in the U.S.",
                },
            ]
        },
    ],
    
}
